import React, {
    IconMail,
    IconMailFast,
    IconPhone,
    IconPrinter,
} from '@tabler/icons-react';
import { Highlight } from '@mantine/core';

import { useOrganisationSearch } from '../../context/OrganisationSearchContext';
import {
    HierarchyUser,
    Maybe,
    ProcurementExecutive,
} from '../../codegen/graphql';
import stringifyNumber from '../../utility/stringifyNumber';

type Props = {
    person?: Maybe<HierarchyUser | ProcurementExecutive>;
    personsRole: 'executive' | 'director' | 'senior-executive';
};

function OpsLeaderCard({ person, personsRole }: Props) {
    const { organisationSearch } = useOrganisationSearch();

    if (!person) {
        return null;
    }

    const borderStyle = () => {
        if (personsRole === 'director') {
            return 'border-t-0 border-x-0 border-b-3';
        }
        if (personsRole === 'senior-executive') {
            return 'border-t-0 border-x-0 border-b-3 mt-4';
        }
        return 'border-r-0 border-y-0 border-l-3';
    };

    return (
        <div
            className={`sticky top-[130px] z-10 flex w-full bg-white border-primary p-6 justify-between shadow-md border-solid ${borderStyle()}`}
        >
            <div className="flex flex-col gap-2 lg:pr-20 min-w-80 flex-shrink-0">
                <Highlight
                    fw=""
                    tt="uppercase"
                    size="xs"
                    highlight={organisationSearch}
                    className="whitespace-nowrap"
                >
                    {person.designation ?? ''}
                </Highlight>
                <Highlight
                    fw="bold"
                    tt="capitalize"
                    size="1.5rem"
                    highlight={organisationSearch}
                    className="whitespace-nowrap"
                >
                    {`${person.firstName ?? ''} ${person.lastName ?? ''}`}
                </Highlight>
            </div>
            <div className="flex flex-col gap-2 w-32">
                <div className="flex gap-2 items-center">
                    <IconMailFast size={20} />
                    <p className="uppercase text-xs ">Speed Dial</p>
                </div>
                <Highlight highlight={organisationSearch}>
                    {person.speedDial || 'N/A'}
                </Highlight>
            </div>
            <div className="flex flex-col gap-2 w-64">
                <div className="flex gap-2 items-center">
                    <IconMail size={20} />
                    <p className="uppercase text-xs">Email</p>
                </div>
                {person.email ? (
                    <a href={`mailto:${person.email}`} className="font-bold">
                        <Highlight highlight={organisationSearch}>
                            {person.email}
                        </Highlight>
                    </a>
                ) : (
                    <Highlight highlight={organisationSearch}>N/A</Highlight>
                )}
            </div>
            <div className="flex flex-col gap-2 w-40">
                <div className="flex gap-2 items-center">
                    <IconPhone size={20} />
                    <p className="uppercase text-xs">Cellphone</p>
                </div>
                <Highlight highlight={organisationSearch}>
                    {stringifyNumber(person.mobileNo) || 'N/A'}
                </Highlight>
            </div>
            <div className="flex flex-col gap-2 w-32">
                <div className="flex gap-2 items-center">
                    <IconPrinter size={20} />
                    <p className="uppercase text-xs">Fax</p>
                </div>
                <Highlight highlight={organisationSearch}>
                    {person.faxNo || 'N/A'}
                </Highlight>
            </div>
        </div>
    );
}

export default OpsLeaderCard;
